module.exports = __webpack_public_path__ + "img/0Q3B8360-70_H_Black_MockedUp.cc6c53b2.jpg";